module.exports = __webpack_public_path__ + "img/8.1a46840f.png";